import React from "react";
import OPOnlineIframe from "../../../iframe-component/operation-online/OPOnIframe";

const OnlineEmailTemplate = () => {
  return <OPOnlineIframe path="/operation/online_email_template" />;
};

export default React.memo(OnlineEmailTemplate);
